import { render, staticRenderFns } from "./trial.vue?vue&type=template&id=89a65474&scoped=true"
import script from "./trial.vue?vue&type=script&lang=js"
export * from "./trial.vue?vue&type=script&lang=js"
import style0 from "./trial.vue?vue&type=style&index=0&id=89a65474&prod&lang=scss"
import style1 from "./trial.vue?vue&type=style&index=1&id=89a65474&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a65474",
  null
  
)

export default component.exports